import { Item } from '../../../../types';
import { ItemState } from '../../../../constants';

export const parseSize = ({
  width,
  height,
}: {
  width: number;
  height: number;
}): [number, number] => [width, height];

interface StatePriority {
  state: ItemState;
  onChange?: (n: Item, isTrue: boolean) => void;
}

export const getStatePriorities = (): StatePriority[] => [
  {
    state: ItemState.Selected,
    onChange: (n: Item, isSelected: boolean) => {
      n.setState(ItemState.Selected, isSelected);
      if (isSelected) {
        n.toFront();
      }
    },
  },
  { state: ItemState.Active },
  { state: ItemState.InlineEdit },
];
